export default [

     {
          path: '/national-risk-manager',
          name: 'NationalRiskManager',
          component: () => import("@/views/Page/NationalRiskManager/NationalRiskManager.vue"),
          meta: {
               title: 'NationalRiskManager',
          },
     }
];